module.exports = __webpack_public_path__ + "img/ic-tooltip-warning.fab02c73.svg";